import { handleResponse } from '@shared/api/handle-response';
import { httpClient } from '@shared/api/http-client';
import type { HandleResponse } from '@shared/api/types';

import { mapUserInfoToAuthUser } from '../lib/user-info';
import type { SessionInfoResponse, UserInfoPayload } from '../model/types';
import { AUTH_USER_INFO_ENDPOINT } from './endpoints';

const normalizeExpiresIn = (expiresIn: UserInfoPayload['expires_in']): number | undefined => {
	const parsedExpiresIn = typeof expiresIn === 'string' ? Number(expiresIn) : expiresIn;
	return Number.isFinite(parsedExpiresIn) ? parsedExpiresIn : undefined;
};

/**
 * Возвращает текущего пользователя и TTL cookie-сессии из BFF.
 */
export const fetchSessionInfo = async (): Promise<HandleResponse<SessionInfoResponse | null>> => {
	const response = await httpClient.get<UserInfoPayload>(AUTH_USER_INFO_ENDPOINT);
	const isOkStatus = response.status >= 200 && response.status < 300;
	if (!isOkStatus) {
		return handleResponse({
			...response,
			data: null,
		});
	}

	const data: SessionInfoResponse = {
		user: mapUserInfoToAuthUser(response.data),
		expiresIn: normalizeExpiresIn(response.data.expires_in),
	};

	return handleResponse({
		...response,
		data,
	});
};
